module.exports = __webpack_public_path__ + "img/r7.3b869cba.jpg";